import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import {AnalyticsWidgetConfig} from '../../config/analyticsWidget.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
import {

  GET_CREDENTIAL_COUNT
} from '../../api/graphql';
import { pretty } from '@vlinder-web/utils-react';
const lookup = require('country-code-lookup');

export interface IAnalyticsWidgetMethods extends IPluginMethodMap {
  getAnalyticsWidgetProps(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class AnalyticeWidgetService implements IAgentPlugin {
  readonly methods: IAnalyticsWidgetMethods;

  constructor() {
    this.methods = {
      getAnalyticsWidgetProps: this.getProps.bind(this),
    };
  }
  async format(config: any) {
    // return config;
    let conf = config;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client.query(GET_CREDENTIAL_COUNT, {
        csme: {
          where: [
            {
              column: 'type',
              op: 'In',
              value: ['CSME_CERTIFICATE'],
            },
          ],
        },
        csmev: {
          where: [
            {
              column: 'type',
              op: 'In',
              value: ['CSME_VERIFICATION'],
            },
          ],
        },
      
        wp: {
          where: [
            {
              column: 'type',
              op: 'In',
              value: ['WORK_PERMIT'],
            },
          ],
        },
        // nwpa: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['APPEALED'],
        //     },
        //   ],
        // },
        
       
        roe: {
          where: [
            {
              column: 'type',
              op: 'In',
              value: ['RIGHTS_OF_ESTABLISHMENT'],
            },
          ],
        },
        
        mec: {
          where: [
            {
              column: 'type',
              op: 'In',
              value: ['MARRIAGE_EXEMPTION_CERTIFICATE'],
            },
          ],
        },
       
        // draftApp: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['APPLICANT_DRAFT', 'APPLICATION_INCOMPLETE'],
        //     },
        //   ],
        // },
        // pendingPaymentApp: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['READY_TO_PAY', 'WAITING_FOR_WP_FEE'],
        //     },
        //   ],
        // },
        // rejectedApp: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['APPLICATION_DENIED'],
        //     },
        //   ],
        // },
        // submittedApp: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['SUBMITTED'],
        //     },
        //   ],
        // },
        // total: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'NotIn',
        //       value: [''],
        //     },
        //   ],
        // },
        // wpissued: {
        //   where: [
        //     {
        //       column: 'status',
        //       op: 'In',
        //       value: ['WP_ISSUED'],
        //     },
        //   ],
        // },
      });
      if (res?.data) {
        console.log(`getApplicationCount-->analystics`, res?.data);
        // countData = res?.data;
        let configg = config?.layout[0]?.colProps?.map((item: any) => {
          // console.log("analystics-->item",item.compProps);

          if (item?.compProps?.id === 'total')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.total,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'cred')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.cred,
                total: res?.data?.cred,
              },
            };
          else if (item?.compProps?.id === 'wp')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.wp,
                total: res?.data?.total,
              },
            };
         
          else if (item?.compProps?.id === 'csme')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.csme,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'mec')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.mec,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'csmev')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.csmev,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'roe')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.roe,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'exem')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.exem,
                total: res?.data?.total,
              },
            };
          else if (item?.compProps?.id === 'waiver')
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                value: res?.data?.waiver,
                total: res?.data?.total,
              },
            };
          else {
            return { ...item, compProps: { ...item?.compProps, value: 0 } };
          }
        });
        // conf = {layout : [{isRowCenter:true,colProps:configg},config?.layout[1]]}
        conf.layout[0] = { isRowCenter: true, colProps: configg };
        console.log('', res);

        console.log('jrambeofre', conf);
        return conf;
      } else {
      }
    } catch (err: any) {
      console.log(`error in table data--->analystics`, err);
    }

    console.log('analystics--->config', config);
    return conf || config;
  }

  async getProps(args: any) {
    console.log(`getDraftApplicationsProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    const filter = {
      year: {
        eq: '2024',
      },
      status: {
        eq: 'active',
      },
    };
    // try {
    //   if (client) {
    //     const _res = await client.query({
    //       query: GET_PRESENTATIONS,
    //       variables: {
    //         filter: filter,
    //         options: {
    //           limit: args?.size ?? 10,
    //           skip: args?.offset ?? 0,
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     const defaultPresentation =
    //       _res?.data?.getPresentations?.content[0]?.id;
    //     const _filter = {
    //       Box___presentation: {
    //         eq: args?.criteria?.id ?? defaultPresentation,
    //       },
    //     };
    //     const res = await client.query({
    //       query: GET_MASQUERADER_DETAILS,
    //       variables: {
    //         filter: _filter,
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       const _map = this.mapFormat(res?.data?.getCountryHeatMap?.data);
    //       const _card = this.cardFormat(res?.data?.getCountryHeatMap?.data);
    //       const formattedData = this.getTransformConfig(config, _map, _card);
    //       let biggestCountObject =_map.reduce((maxCountObj, currentObj) => {
    //           if (currentObj.count > maxCountObj.count) {
    //             return currentObj;
    //           }
    //           return maxCountObj;
    //         }, _map[0]);

    //       return {
    //         map: config,
    //         highest: biggestCountObject?.count !== undefined ? biggestCountObject?.count : 0
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   let _display_message =
    //   err?.graphQLErrors &&
    //   Array.isArray(err?.graphQLErrors) &&
    //   err?.graphQLErrors.find((item: any) => item.extensions);
    // if (_display_message?.extensions?.display_message) {
    //   throw Error(_display_message?.extensions?.display_message);
    // }

    // throw err;
    // }
    console.log('analytics-->config', AnalyticsWidgetConfig);
    return { ...((await this.format(AnalyticsWidgetConfig)) || {}) };
  }

  private getTransformConfig(data: any, map?: any, card?: any) {
    data.layout[0].colProps[8].compProps.data = map;
    console.log('card==>', pretty(card.length));
    let count = 0;
    if (card.length != 0) {
      card.forEach((item: any) => {
        data.layout[0].colProps[count++].compProps = item;
      });
      for (let i = card.length; i < 8; i++) {
        data.layout[0].colProps[count++].compProps = {};
      }
    } else {
      for (let i = 0; i < 8; i++) {
        data.layout[0].colProps[count++].compProps = {};
      }
    }
    const jsonString = JSON.stringify(data);
    return JSON.parse(jsonString);
  }

  private mapFormat(data: any) {
    const _checkValueIs = (country: string) => {
      return lookup.byCountry(country)?.internet;
    };
    let _data: any[] = [];
    data.forEach((item: any) => {
      let country = _checkValueIs(item?.Name);
      if (country !== undefined) {
        _data.push(item?.ISO3);
      }
    });
    const cty = Array.from(new Set(_data));
    let arr: any[] = [];
    cty.forEach((item: any) => {
      let count = 0;
      let Name = '';
      data.forEach((obj: any) => {
        if (item === obj.ISO3) {
          Name = obj.Name;
          count += Number(obj.count);
        }
      });
      arr.push({
        ISO3: item,
        Name: Name,
        count: count,
      });
    });
    return arr;
  }

  private cardFormat(data: any) {
    const _checkValueIs = (country: string) => {
      return lookup.byCountry(country)?.internet;
    };
    let _data: any[] = [];
    data.forEach((item: any) => {
      let country = _checkValueIs(item?.Name);
      if (country !== undefined) {
        _data.push(item?.ISO3);
      }
    });
    const cty = Array.from(new Set(_data));
    let arr: any[] = [];
    cty.forEach((item: any) => {
      let count = 0;
      let Name = '';
      data.forEach((obj: any) => {
        if (item === obj.ISO3) {
          Name = obj.Name;
          count += Number(obj.count);
        }
      });
      arr.push({
        ISO3: item,
        Name: Name,
        count: count,
      });
    });
    if (arr.length > 1) {
      arr.sort((a, b) => {
        if (a.count !== b.count) {
          return b.count - a.count;
        }
        return a.Name.localeCompare(b.Name);
      });
    }

    if (arr.length > 8) arr = arr.slice(0, 8);
    let card: any[] = [];
    let x = 0;
    arr.forEach((item: any) => {
      card.push({
        appCardId: x++,
        appCardISO3: item?.ISO3,
        appCardTitle: item?.Name,
        appCardList: [
          {
            name: 'Count',
            value: item?.count,
          },
        ],
      });
    });
    return card;
  }
}
